import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useGuestAuth } from "@/contexts/GuestAuthContext";
import { Award, UserPlus } from "lucide-react";
import { Link } from "react-router-dom";

export function GuestAreaPromoBanner() {
  const { config, profile } = useGuestAuth();

  if (!config?.isEnabled) return null;

  if (profile) {
    return (
      <Card className="overflow-hidden border border-border bg-card shadow-none">
        <CardContent className="p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-start sm:items-center gap-3.5 min-w-0">
            <div
              className="size-11 rounded-lg flex items-center justify-center text-primary-foreground bg-primary shrink-0"
              aria-hidden="true"
            >
              <Award className="size-5" />
            </div>
            <div className="min-w-0 space-y-0.5">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs font-medium text-muted-foreground">
                  {profile.programName}
                </span>
                <Badge variant="secondary" className="text-xs font-semibold">
                  {profile.fidelityType}
                </Badge>
              </div>
              <h2 className="text-base font-bold text-foreground truncate">
                {profile.name}, saldo attuale:{" "}
                <span className="text-primary">
                  {Math.round(profile.currentPoints)} punti
                </span>
              </h2>
              <p className="text-xs sm:text-sm text-muted-foreground">
                {profile.nextFidelityType
                  ? `Mancano ${Math.round(profile.pointsToNextTier)} punti per il livello ${profile.nextFidelityType}.`
                  : "Hai raggiunto il livello più alto del programma fedeltà."}
              </p>
            </div>
          </div>

          <Button asChild className="min-h-11 px-4 shrink-0 w-full sm:w-auto">
            <Link to="/guest-area">Apri la tua Guest Area</Link>
          </Button>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="overflow-hidden border border-border bg-card shadow-none">
      <CardContent className="p-4 sm:p-5 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div className="flex items-start gap-3.5 min-w-0">
          <div
            className="size-11 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0 mt-0.5"
            aria-hidden="true"
          >
            <Award className="size-5" />
          </div>
          <div className="space-y-1 min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs font-semibold text-primary">
                {config.programName}
              </span>
              {config.welcomeBonusPoints > 0 && (
                <Badge variant="secondary" className="text-xs font-medium">
                  +{config.welcomeBonusPoints} punti alla registrazione
                </Badge>
              )}
            </div>
            <h2 className="text-base font-bold text-foreground">
              Accumula punti con il soggiorno e i servizi richiesti in hotel
            </h2>
            <p className="text-xs sm:text-sm text-muted-foreground max-w-2xl leading-relaxed">
              Registrati alla Guest Area di{" "}
              <strong className="font-semibold text-foreground">
                {config.isOrganizationCentralized
                  ? config.organizationName || config.structureName
                  : config.structureName}
              </strong>{" "}
              ({config.pointsPerSpendUnit} pt ogni {config.spendUnitAmount} € di
              spesa) per attivare la tessera fedeltà e consultare lo storico dei
              tuoi soggiorni.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2.5 shrink-0">
          <Button
            asChild
            variant="outline"
            className="min-h-11 px-4 shadow-none"
          >
            <Link to="/guest-area/login">Accedi</Link>
          </Button>
          <Button asChild className="min-h-11 px-4 gap-2">
            <Link to="/guest-area/register">
              <UserPlus className="size-4" aria-hidden="true" />
              <span>Attiva tessera</span>
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
